export default "/images/abc.png?ff6b1356e3df97bb5326189299b547bb";